import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../types';
import { getOperatorDetail } from './operator.selector';

const getProviders = function (state: RootState) {
  return state.provider;
};

const getVditransactions = function (state: RootState) {
  return state.vdiTransaction;
};

export const getProviderList = createSelector(
  getProviders,
  (providers) => providers,
);

export const providerList = createSelector(getProviders, (providers) => {
  return providers?.providers?.data?.map((provider) => ({
    id: provider?.providerId,
    name: provider?.name,
  }));
});

export const getVdiTransactionDetail = createSelector(
  getVditransactions,
  (vditransaction) => vditransaction,
);

export const getVdiTransactionList = createSelector(
  providerList,
  getOperatorDetail,
  getVditransactions,
  (provider, operator, vditransactions) => {
    return vditransactions;
  },
);
